import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import { ROUTES } from "../routes";
import {
  AUTHORIZATION,
  CSRF_TOKEN,
  HEADER_X_REQUEST_ID,
  REGION,
} from "../consts/AppContants";
import { AUTH_LOCAL_VARIABLES } from "../store/features/authSlice";
import { v4 as uuid_v4 } from "uuid";

const ERROR_STATUS = {
  UNAUTHORIZED: "UNAUTHORIZED",
  EXPECTATION_FAILED: "EXPECTATION_FAILED",
};

// Request Interceptor Handler
export const InterceptorRequestHandler = (req) => {
  if (!navigator.onLine) {
    toast("Please Check Internet Connection..", {
      type: "error",
      theme: "colored",
    });
    return;
  }

  req.headers[REGION] = "UAE";
  req.headers[HEADER_X_REQUEST_ID] = uuid_v4();
  req.headers[AUTH_LOCAL_VARIABLES.csrf] = secureLocalStorage.getItem(
    AUTH_LOCAL_VARIABLES.csrf
  );
  req.headers[AUTHORIZATION] = secureLocalStorage.getItem(
    AUTH_LOCAL_VARIABLES.auth_token
  );
  return req;
};

// Response Interceptor Handler
export const InterceptorResponseHandler = (res) => {
  if (res.headers[AUTH_LOCAL_VARIABLES.auth_token]) {
    secureLocalStorage.setItem(
      AUTH_LOCAL_VARIABLES.auth_token,
      res.headers[AUTH_LOCAL_VARIABLES.auth_token]
    );
  }

  // checking csrf token
  if (res.headers[AUTH_LOCAL_VARIABLES.csrf]) {
    secureLocalStorage.setItem(
      AUTH_LOCAL_VARIABLES.csrf,
      res.headers[AUTH_LOCAL_VARIABLES.csrf]
    );
  }
};

export const InterceptorResponseErrorHandler = (error) => {
  // check for network error
  if (error?.code === "ERR_NETWORK") {
    toast(error?.message, {
      type: "error",
    });
  }

  if (error.response) {
    const { status } = error?.response?.data;

    if (ERROR_STATUS[status]) {
      secureLocalStorage.clear();
      localStorage.clear();
      sessionStorage.clear();
      window.location = ROUTES.LOGIN;
    }

    toast(error.response?.data?.message, {
      type: "error",
    });
  }
};
